import React, { useState, useEffect, useRef, useContext } from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import PropTypes from 'prop-types'
import PageLink from '../animations/PageLink'
import Logo from '../../graphics/logo.svg'
import { motion, AnimatePresence } from "framer-motion";
import DisplayContext from '../../contexts/DisplayContext'

const MenuComponent = ({ className }) => {

  const display = useContext(DisplayContext);

  const ref = useRef();
  const [isOpen, setIsOpen] = useState(false);

  useOnClickOutside(ref, () => {
    setIsOpen(false);
  });

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  };

  const container = {
    hide: { 
      transition: {
        staggerChildren: 0.1,
        staggerDirection: -1
      },
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    }
  }
  
  const item = {
    hide: { 
      y: -20,
      opacity: 0,
    },
    show: { 
      y: 0,
      opacity: 1,
    }
  }

  return (
    <Nav role="navigation" className={className} aria-label="main-navigation" ref={ref}>
      <span className="logo"><Logo onClick={toggleMenu} /></span>
      {display == 'live' && (
        <AnimatePresence>
          {isOpen && (
            <motion.ul
              className="menu"
              variants={container}
              initial="hide"
              animate="show"
              exit="hide"
            >
              <motion.li variants={item}><PageLink to="/">Home</PageLink></motion.li>
              <motion.li variants={item}><PageLink to="/individuals">For individuals</PageLink></motion.li>
              <motion.li variants={item}><PageLink to="/businesses">For business</PageLink></motion.li>
              <motion.li variants={item}><PageLink to="/schools">For schools &amp; institutions</PageLink></motion.li>
              <motion.li variants={item}><PageLink to="/team">Team</PageLink></motion.li>
            </motion.ul>
          )}
        </AnimatePresence>
      )}
    </Nav>
  )

}

MenuComponent.propTypes = {
  className: PropTypes.string.isRequired,
}

function useOnClickOutside(ref, handler) {
  useEffect(
    () => {
      const listener = event => {
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }

        handler(event);
      };

      document.addEventListener('mousedown', listener);
      document.addEventListener('touchstart', listener);

      return () => {
        document.removeEventListener('mousedown', listener);
        document.removeEventListener('touchstart', listener);
      };
    },
    [ref, handler]
  );
}

const Nav = styled.nav`
  ${tw`flex items-center`}
`
  
const Menu = styled(MenuComponent)`
  ${tw``}
  .logo {
    position: relative;
    z-index: 2;
    :hover {
      cursor: pointer;
    }
  }
  .menu {
    position: absolute;
    z-index: 1;
    top: calc(100% + 8px);
    list-style-type: none;
    margin: 0;
    padding: 0;
    li {
      display: block; 
      margin: 0;
      width: 240px;
    }
    li:nth-of-type(1) {
      background-color: #B5B4B4;
    }
    li:nth-of-type(2) {
      background-color: #C4C4C4;
    }
    li:nth-of-type(3) {
      background-color: #D9D9D9;
    }
    li:nth-of-type(4) {
      background-color: #E5E5E5;
    }
    li:nth-of-type(5) {
      background-color: #f1f1f1;
    }
    li a {
      color: #000;
      text-decoration: none;
      display: block;
      padding: 8px;
      transition: all 0.5s ease-in-out;
    }
    li a:hover {
      background-color: rgb(255, 129, 242);
    }
  }
`

export default Menu;